export default function getImageUrl(imgUrl: string) {
  // image 가 http일 경우 https 만 허용하는 브라우저에서는 깨져보이기 때문에 처리
  // 추후에 서버에서 https 로 내려주는 방식으로 수정해야 함.
  return imgUrl.replace(/^http:\/\//i, '//');
};
